import React from 'react';
const steps = [{
  title: 'You tell us about your business',
  body: 'One short intake: what you do, who you serve, and where your leads come from today.'
}, {
  title: 'We build your site shell in 72 hours',
  body: 'Structure, pages, and layout live and viewable — built for your business, not a template demo.'
}, {
  title: 'You review it and request changes through Slack',
  body: 'Message what you want changed. MISTR, our AI, makes the edits — no developer queue, no change-request forms, for as long as you are with us.'
}];
export function Process() {
  return <section className="bg-brand-white" aria-labelledby="process-heading" data-id="element-134" data-mp="1foh01sdpw1ih">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-20 lg:py-24" data-id="element-135" data-mp="1kf5spb14v4j7">
        <h2 id="process-heading" className="max-w-2xl font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl" data-id="element-136" data-mp="1kha74mwnrlxq">
          Why 72 hours is possible — and why it stays easy after
        </h2>
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-brand-gray" data-id="element-137" data-mp="19lhcncvki1gy">
          The speed is not a one-time sprint. The same channel that gets you live in three days is
          how every change gets made from then on.
        </p>

        <ol className="mt-12 grid gap-px bg-brand-light sm:grid-cols-3" data-id="element-138" data-mp="10r2vf4rh8gv7">
          {steps.map((step, index) => <li key={step.title} className="flex flex-col bg-brand-white p-7 sm:p-8" data-id="element-139" data-mp="vs01oggy5x2j" data-mpi={index}>
              <span className="font-display text-5xl font-extrabold leading-none text-brand-red" data-id="element-140" data-mp="qsn7fanqxnpx">
                {index + 1}
              </span>
              <h3 className="mt-5 font-display text-lg font-bold leading-snug" data-id="element-141" data-mp="ht9v8a88ml1i">{step.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-brand-gray" data-id="element-142" data-mp="cvi77raprj2l">{step.body}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}